module.exports = __webpack_public_path__ + "media/images/amenities_icons/mini_golf_course-24aec14e81535ea5d8451d13bf9779e7.svg";